import { graphql, useStaticQuery } from 'gatsby'
import * as React from 'react'
import { useMemo } from 'react'
import { Footer } from '../../components/Layout/Footer'
import { Translation } from '../../lib/context/i18n/interfaces'
import { useCurrentLanguageKey } from '../../lib/context/i18n'
import { defaultLanguage, LANGUAGE } from '../../../config/storyblok/languages'

const navigationQuery = graphql`
  query {
    allStoryblokEntry(filter: { field_component: { eq: "Footer" } }) {
      nodes {
        id
        name
        uuid
        lang
        content
      }
    }
  }
`

export const PageFooter = () => {
  const footer = useStaticQuery(navigationQuery)
  const currentLanguage = useCurrentLanguageKey()

  const allHeaderData = useMemo(() => {
    const mappedTranslations: Record<LANGUAGE, Translation> | {} = {}

    if (footer) {
      const { allStoryblokEntry: allStoryblokEntry } = footer

      allStoryblokEntry?.nodes?.forEach(source => {
        let key = source.lang === 'default' ? defaultLanguage : source.lang
        let value = source

        if (!mappedTranslations[key]) {
          mappedTranslations[key] = {}
        }

        mappedTranslations[key] = value
      })
    }

    return mappedTranslations
  }, [footer])

  return <Footer footerData={allHeaderData[currentLanguage]} />
}
